import React from 'react';
import BasicMeta from '../BasicMeta';

const descriptions = {
  se: {
    description: 'Lyssna på vår Hockey podcast och vår motor Podcast.',
    title: 'Podcasts',
  },
  no: {
    description: 'Viasat NFL Podcast holder deg oppdatert på det som skjer i National Football League, på norsk.',
    title: '',
  },
  dk: {
    description: '',
    title: '',
  },
  fi: {
    description: '',
    title: '',
  },
};

export default class PodMeta extends React.PureComponent {
  render() {
    return (
       <BasicMeta descriptions={descriptions} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/MediaPages/PodMeta.jsx